import { Reveal } from "@/components/site/Reveal";
import { FAQS } from "@/data/content";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const FAQ = () => (
  <section id="faq" className="bg-white py-20 sm:py-28" data-testid="faq-section">
    <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-center text-sm font-bold uppercase tracking-widest text-emerald-700">Questions</p>
        <h2 className="mt-3 text-center font-display text-4xl font-black tracking-tight text-slate-900 sm:text-5xl">
          Frequently Asked Questions
        </h2>
      </Reveal>
      <Reveal delay={0.08}>
        <Accordion type="single" collapsible className="mt-10 space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`}
              className="overflow-hidden rounded-2xl border border-slate-200 bg-slate-50 px-6">
              <AccordionTrigger className="py-5 text-left font-display text-base font-bold text-slate-900 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-slate-600">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
